export default {
  fileUrl: state => fileId => {
    return state.files[fileId]
  }
}
